import { useEffect, useState } from 'react';

import { JWT } from 'domains/jwtToken/types';

import { IProjectSubchains } from './useProjectSubchains';

export interface UseIsAllSelectedProps {
  allCurrentChainPaths: string[];
  isLoadingAddChainsToProjects: boolean;
  projects: JWT[];
  selectedSubchains: IProjectSubchains;
}

interface CheckIsAllSelectedParams
  extends Omit<UseIsAllSelectedProps, 'isLoadingAddChainsToProjects'> {}

const checkIsAllSelected = ({
  allCurrentChainPaths,
  projects,
  selectedSubchains,
}: CheckIsAllSelectedParams) =>
  projects.every(({ userEndpointToken }) =>
    allCurrentChainPaths.every(path =>
      selectedSubchains[userEndpointToken]?.includes(path),
    ),
  );

export const useIsAllSelected = ({
  allCurrentChainPaths,
  isLoadingAddChainsToProjects,
  projects,
  selectedSubchains,
}: UseIsAllSelectedProps) => {
  const [isAllSelected, setIsAllSelected] = useState(
    checkIsAllSelected({ allCurrentChainPaths, projects, selectedSubchains }),
  );

  useEffect(() => {
    if (!isLoadingAddChainsToProjects) {
      setIsAllSelected(
        checkIsAllSelected({
          allCurrentChainPaths,
          projects,
          selectedSubchains,
        }),
      );
    }
  }, [
    allCurrentChainPaths,
    isLoadingAddChainsToProjects,
    projects,
    selectedSubchains,
  ]);

  return isAllSelected;
};
